export const styles = {
    root: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        padding: '8px',
    },
    content: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px 12px',
        background: '#F9F9F9',
    },
    viewer: {
        width: 'min(800px, 94vw)',
        height: 'min(600px, 72vh)',
        background: '#F9F9F9',
        boxShadow: '0 0 24px 6px rgba(0,0,0,0.35)',
    },
    hint: {
        marginTop: 8,
        color: '#696969',
    },
    info: {
        marginTop: 16,
        textAlign: 'center',
    },
    meta: {
        marginTop: 4,
    },
    btn: {
        marginTop: 20,
    },
    status: {
        marginTop: 8,
        color: '#696969',
        minHeight: 18,
        textAlign: 'center',
    },
    errorBox: {
        marginTop: 20,
        padding: '12px 16px',
        background: '#fff3f3',
        border: '1px solid #f44336',
        borderRadius: 2,
        color: '#c62828',
        maxWidth: 480,
        width: '90vw',
        textAlign: 'center',
    },
    warningBox: {
        marginTop: 20,
        padding: '12px 16px',
        background: '#fffde7',
        border: '1px solid #f9a825',
        borderRadius: 2,
        color: '#7a5800',
        maxWidth: 480,
        width: '90vw',
        textAlign: 'center',
    },
};
